import Vue from "vue";
import Toast from "vue2-toast";
import { Option, Select, Checkbox } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "vue2-toast/lib/toast.css";
import axios from "axios";

import router from "./router";
import App from "./App";
import store from "./store";
import { getToken } from "./utils/auth";

Vue.config.productionTip = false;
Vue.use(Option);
Vue.use(Select);
Vue.use(Checkbox);
Vue.use(Toast, {
  type: "center",
  duration: 3000,
  wordWrap: true
});
Vue.prototype.$axios = axios;
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!getToken("ppinf")) {
      next({
        path: "/"
      });
    } else {
      next();
    }
  } else {
    next(); // 确保一定要调用 next()
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
